<div class="page-content">
  <!-- Page Header -->
  <div class="content-head">
    <div>
      <div class="eyebrow">WORKSPACE PREFERENCES</div>
      <h2>Settings</h2>
      <p>Customize the dashboard for your placement office.</p>
    </div>
    <button type="button" class="primary-button" (click)="saveChanges()">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
      Save changes
    </button>
  </div>

  <!-- Settings Panel -->
  <section class="panel overflow-visible">
    <div class="panel-heading">
      <h2>Dashboard defaults</h2>
    </div>

    <div class="settings-form">
      <!-- Default academic year -->
      <div class="form-row">
        <span>Default academic year</span>
        <app-custom-select
          [value]="localYear"
          [options]="yearOptions"
          iconType="calendar"
          (valueChange)="localYear = $event">
        </app-custom-select>
      </div>

      <!-- Default department view -->
      <div class="form-row">
        <span>Default department view</span>
        <app-custom-select
          [value]="localDept"
          [options]="deptOptions"
          iconType="graduation"
          (valueChange)="localDept = $event">
        </app-custom-select>
      </div>

      <!-- Weekly summary emails -->
      <div class="form-row">
        <span>Weekly summary emails</span>
        <div 
          class="toggle" 
          [class.active]="localWeekly" 
          (click)="localWeekly = !localWeekly"
          role="switch"
          [attr.aria-checked]="localWeekly"
          tabindex="0">
          <i></i>
        </div>
      </div>

      <!-- New opportunity alerts -->
      <div class="form-row">
        <span>New opportunity alerts</span>
        <div 
          class="toggle" 
          [class.active]="localAlerts" 
          (click)="localAlerts = !localAlerts"
          role="switch"
          [attr.aria-checked]="localAlerts"
          tabindex="0">
          <i></i>
        </div>
      </div>

      <!-- Practice Credit Usage -->
      <div class="form-row">
        <div class="credit-label-wrap">
          <span>Practice Credit Usage</span>
          <small class="credit-subtext">
            Show separate practice assessment and practice interview credit usage in student records.
          </small>
        </div>
        <div 
          class="toggle" 
          [class.active]="localPractice" 
          (click)="localPractice = !localPractice"
          role="switch"
          [attr.aria-checked]="localPractice"
          tabindex="0">
          <i></i>
        </div>
      </div>
    </div>
  </section>
</div>
